/** Cheap / simplistic test to check if a string is a valid ASCII tab */
export function isAsciiTab(tab: string): boolean {
  const lines = tab.split('\n')
  // Allow optional space between string label and pipe (tabToAscii uses "e |..." format)
  const tabLines = lines.filter(line => /^[eBGDAE]\s*\|[-0-9hpsbrt]*.*\|/.test(line))

  // Guitar tabs have 6 strings, bass tabs have 4 strings
  // Accept either format
  return tabLines.length >= 4 && tabLines.length <= 6
}
